import React from 'react';
import { AppBar, Toolbar, Typography, Button, Icon } from '@mui/material';
import SSNM3_LOGO from "../assets/ssnm3_2.svg"

const NavBar = () => {
  return (
    <AppBar position="sticky" color="primary" className="navbar">
      <Toolbar>
        <Typography variant="h6" className="navbar-title">
          SSNM3
          {/* <img src="/assets/ssnm3_5.svg" alt="logo" width="60" height="60" /> */}
        </Typography>
        <Button color="inherit" href="#home">Home</Button>
        <Button color="inherit" href="#services">Services</Button>
        <Button color="inherit" href="#features">Features</Button>
        {/* <Button color="inherit" href="#testimonials">Testimonials</Button> */}
        <Button color="inherit" href="#contact">Contact</Button>
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
